/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AvailableOrderTypes {
	batchDelivery = "batchDelivery",
	delivery = "delivery",
	pickup = "pickup"
}

export enum DaysOfWeek {
	fri = "fri",
	mon = "mon",
	sat = "sat",
	sun = "sun",
	thu = "thu",
	tue = "tue",
	wed = "wed"
}

export enum OrderStatuses {
	awaitingPayment = "awaitingPayment",
	cancelledByBusiness = "cancelledByBusiness",
	cancelledByCustomer = "cancelledByCustomer",
	completed = "completed",
	confirmed = "confirmed",
	new = "new",
	outForDelivery = "outForDelivery",
	paymentFailed = "paymentFailed",
	placed = "placed",
	ready = "ready",
	scheduled = "scheduled"
}

export interface AddressInput {
	address1?: string | null;
	address2?: string | null;
	address3?: string | null;
	city: string;
	state?: string | null;
	postalCode?: string | null;
	country?: string | null;
	placeId?: string | null;
	place?: any | null;
}

export interface MutationAddToCartInput {
	businessId: string;
	orderId?: string | null;
	menuId: string;
	menuGroupId: string;
	menuItemId: string;
	item: MutationAddToCartItemInput;
}

export interface MutationAddToCartItemInput {
	localId: string;
	specialInstructions?: string | null;
	quantity: number;
	selectedOptions?: MutationAddToCartSelectedOptionInput[] | null;
	unitPriceCents: number;
	extendedPriceCents: number;
}

export interface MutationAddToCartSelectedOptionInput {
	menuItemOptionId: string;
	menuItemOptionGroupId?: string | null;
}

export interface MutationBeginOrderPlacementCustomerInput {
	fullName: string;
	phoneNumber: string;
	email: string;
}

export interface MutationBeginOrderPlacementInput {
	businessId: string;
	orderId?: string | null;
	orderItems: MutationBeginOrderPlacementOrderItemInput[];
	customer: MutationBeginOrderPlacementCustomerInput;
	deliveryAddress?: AddressInput | null;
	orderSubTotalCents: number;
	taxCents: number;
	tipCents?: number | null;
	orderTotalCents: number;
	promoCode?: string | null;
	discount?: number | null;
	orderType?: MutationBeginOrderPlacementOrderTypeInput | null;
	preparationTimeMinutes: number;
	deliveryOrPickupAt?: any | null;
}

export interface MutationBeginOrderPlacementOrderItemInput {
	localId: string;
	menuItem: MutationBeginOrderPlacementOrderItemMenuItemInput;
	specialInstructions?: string | null;
	quantity: number;
	selectedOptions: MutationBeginOrderPlacementOrderItemSelectedOptionInput[];
	unitPriceCents: number;
	extendedPriceCents: number;
}

export interface MutationBeginOrderPlacementOrderItemMenuItemInput {
	id: string;
	priceCents?: number | null;
	displayPrice?: string | null;
	preparationTimeMinutes?: number | null;
}

export interface MutationBeginOrderPlacementOrderItemSelectedOptionInput {
	id: string;
	priceCents?: number | null;
	displayPrice?: string | null;
	preparationTimeMinutes?: number | null;
}

export interface MutationBeginOrderPlacementOrderTypeInput {
	orderTypeId: string;
	orderType: AvailableOrderTypes;
}

export interface MutationClearCartInput {
	businessId: string;
	orderId?: string | null;
}

export interface MutationCompleteOrderPlacementInput {
	businessId: string;
	orderId: string;
}

export interface MutationRemoveFromCartInput {
	businessId: string;
	orderId?: string | null;
	item: MutationRemoveFromCartItemInput;
}

export interface MutationRemoveFromCartItemInput {
	localId: string;
}

export interface MutationUpdateOrderCustomerInput {
	businessId: string;
	orderId?: string | null;
	fullName: string;
	phoneNumber: string;
	email: string;
	deliveryAddress?: AddressInput | null;
}

export interface QueryBusinessInput {
	businessId?: string | null;
	businessSlug?: string | null;
}

export interface QueryOrderInput {
	orderId: string;
	refreshStatus?: boolean | null;
	tempAccessToken?: string | null;
}

export enum PromoCodeStatus {
	invalid = "INVALID",
	active = "ACTIVE",
	applied = "APPLIED"
}

//==============================================================
// END Enums and Input Objects
//==============================================================
